package io.horion.cv.components.layouts

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.style.toModifier
import io.horion.cv.api.utils.Constants.AUTH_URL
import io.horion.cv.api.utils.TokenRepository
import io.horion.cv.api.config.HttpClient
import io.horion.cv.components.widgets.AppSidebar
import io.horion.cv.pages.dashboard.TopbarDashboard
import io.horion.cv.styles.DashboardContentStyle
import io.horion.cv.styles.DashboardMainContentStyle
import io.horion.cv.styles.DesktopOnlyStyle
import io.horion.cv.styles.MobileOnlyStyle
import io.horion.cv.utils.Colors
import io.ktor.client.request.get
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.vh

@OptIn(DelicateApi::class)
@Composable
fun AppResponsiveLayout(
    activeLabel: String,
    content: @Composable () -> Unit
) {
    val ctx = rememberPageContext()

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .minHeight(100.vh)          // la page peut dépasser 100vh, jamais moins
            .backgroundColor(Colors.PriceGray)
    ) {
        Box(modifier = MobileOnlyStyle.toModifier().fillMaxWidth()) {
            TopbarDashboard()
        }

        Row(
            modifier = Modifier
                .fillMaxWidth()
                .styleModifier { property("align-items", "stretch") } // explicite, au cas où
        ) {
            Box(
                modifier = DesktopOnlyStyle.toModifier()
                    .fillMaxHeight() // suit la hauteur du Row, PAS 100vh fixe
                    .styleModifier {
                        // reste visible pendant le scroll, colle au viewport
                        property("position", "sticky")
                        property("top", "0")
                        property("height", "100vh") // uniquement pour le "sticky", pas comme contrainte du Row
                        property("align-self", "flex-start")
                    }
            ) {
                AppSidebar(
                    activeLabel = activeLabel,
                    onNav = { path -> ctx.router.navigateTo(path) },
                    onLogout = {
                        TokenRepository.set(null)
                        MainScope().launch {
                            runCatching {
                                HttpClient.clientAuth.get("$AUTH_URL/logout-local?service=CV")
                            }
                        }
                        ctx.router.navigateTo("/")
                    }
                )
            }

            Column(
                modifier = if (activeLabel == "Tableau de bord") {
                    DashboardMainContentStyle.toModifier()
                } else {
                    DashboardContentStyle.toModifier()
                }
            ) {
                content()
            }
        }
    }
}
